import React from 'react';
import { ButtonSingle, ButtonDouble } from './buttons' 
import { PageTakeFotoForm } from './takeFoto/takeFotoFrom'
import { RegistroForm } from './registroForm'

import  logoRayados from './../assets/logo.png';
import  splashfinal from './../assets/imagen_final.jpg';
import escudo from './../assets/escudo.png';

import axios from 'axios';

//import ApolloClient from 'apollo-boost';
import { gql } from "apollo-boost";


type MyPropsButon = {
     actionNext:any
}


type MyState = { 
};
   
export class PageWelcome extends React.Component<MyPropsButon, MyState>{
     render =() => 
          <div className="PageWelcome">
          <div className="center"><img src={logoRayados} className="logo animated fadeIn delay-500ms" alt="Logo rayados"/></div>
          <h3 className="animated fadeIn delay-1000ms">¡Vas de titular en casa!</h3>
          <div className="animated fadeIn delay-1500ms">
               <p className="center">En este regreso a la cancha, ¡#ElJugador12 va de titular en Casa!</p>
               <p className="center">Apoyemos acompañando al Equipo y hagamos la diferencia. Tómate tu foto rayada y asegura tu lugar en el 
                    Estadio BBVA para nuestros partidos de local que se jueguen a puerta cerrada en el Apertura 2020</p>
               <p className="center">A través de tu donativo, aportarás al movimiento Unir y Dar y su iniciativa #AbrazaNL, la cual 
                    brinda ayuda social asistiendo las necesidades básicas de alimentación, servicios y medicinas de quienes se han quedado sin empleos a causa de la contingencia sanitaria.</p> 
               <p className="center">¡Sumemos esfuerzos y sigamos haciendo Equipo #EnLaVidaYEnLaCancha!</p>
               <p className="center">Aquellas personas que hagan su donativo a partir del 14 de julio, verán su silueta colocada hasta la J3.</p>
               <br />
          </div>
          <ButtonSingle click={this.props.actionNext} value="Continuar" priority="high" className="animated fadeIn delay-2000ms"/>
     </div>
}

type MyProps2Butons = {
     actionNext:any
     actionPrev:any
}

export class PagePrivacy extends React.Component<MyProps2Butons, MyState>{
     render =() => 
     <div className="PagePrivacy">
          <div className="center"><img src={logoRayados} className="logo" alt="Logo rayados" /></div>

          <h3>Conoce tus opciones de donativo:</h3>
          <ul>
          <li><strong>$199</strong> - Tu silueta Rayada será impresa y colocada en las tribunas del Estadio BBVA para que apoyes al Equipo desde las gradas en los 
               partidos de local que se realicen a puerta cerrada.</li>
               <li className="tachado"><strong>$349</strong> - Además de adquirir tu silueta Rayada, participas para llevártela autografiada por tu jugador favorito del Primer Equipo una vez 
               que se termine la campaña.</li>
               <li className="tachado"><strong>$699 </strong>- Además de adquirir tu silueta Rayada, participas para ganarte el nuevo jersey local PUMA de la temporada 2020-2021.</li>                                            
          </ul>
          <p>*En cualquier opción seleccionada, todas las ganancias de tu aportación serán donadas a Unir y Dar. </p>         
          <br /><br /><br />
          <h3>Términos y condiciones concurso <br /> “El jugador #12”</h3>
          <div className="privacy">
          <p>(I) De conformidad con el Artículo 87 de la Ley Federal del Derecho de Autor, autorizo expresamente al Club de Futbol Monterrey Rayados, A.C. 
               (en adelante el “Club”) para que utilice mi imagen durante los partidos celebrados a puerta cerrada, en el Estadio BBVA, en el transcurso del 
               Torneo Clausura o Apertura de la Liga MX, Copa MX o cualquier otro que corresponda. Ahora bien, certifico que los derechos de la imagen que estoy 
               utilizando en la presente dinámica me pertenecen y, en caso contrario, me obligo a no utilizarla o conseguir el consentimiento del titular de dicha 
               imagen para tal efecto. En virtud de lo anterior, me obligo expresamente a sacar en paz y a salvo al Club de cualquier reclamación que pudiera surgir con motivo de la presente dinámica</p>

          <p>(II) El Club se reserva el derecho de imprimir y/o colocar siluetas que contengan mensajes o señas ofensivas, agravantes, difamatorias, propaganda, 
               imágenes alusivas a otros equipos de fútbol, entre otros, que sean considerados inadecuados bajo los principios del Código de Ética del Club, mismos que pueden ser consultados en: 
               https://www.rayados.com/monterrey/estadio_codigo-de-etica.</p>

          <p>(III) En caso de que el Torneo Clausura o Apertura de la Liga MX, Copa MX o cualquier otro que corresponda sea reanudado de forma normal (con asistentes presentes) o cancelado, estoy consciente de que mi silueta Rayada ya no será utilizada.</p>

          <p>(IV) Las rifas antes mencionadas se sujetarán a lo siguiente:</p>
          <p>(V) Al donar los $349.00 pesos, participas automáticamente en una rifa para ser uno de los 10 (diez) ganadores de tu silueta Rayada autografiada por tu jugador favorito del plantel actual del Primer Equipo.</p>

          <p>(VI) Al realizar el donativo de $699.00 pesos, tendrás derecho a la participación en una rifa para ganar 1 (un) jersey local PUMA del Primer Equipo, versión aficionado, correspondiente a la temporada 2020-2021, 
               la talla será elegida libremente por el ganador, sujeto a disponibilidad. </p>     

          <p>(VII) Las rifas antes mencionadas se llevarán a cabo el día 30 de julio del presente año y los resultados serán comunicados a los ganadores por medio del correo electrónico que señalaron en el registro. Lo anterior, 
               en el entendido de que en caso de no responder dentro de los 3 (tres) días naturales siguientes a aquel en que el correo fue enviado por el Club, se seleccionará un nuevo ganador.</p>
               
          <p>(VIII) El tratamiento de datos personales se limitará al cumplimiento de las finalidades previstas en el Aviso de Privacidad, el cual se
                encuentra disponible en el sitio web: https://www.rayados.com/monterrey/aviso-de-privacidad</p>

          <p>(IX) Los Términos y Condiciones que rigen el uso que usted le dé al presente sitio, se encuentran disponibles en el sitio web: https://www.rayados.com/monterrey/terminos-y-condiciones</p>

          </div>
          <br />
          <ButtonDouble next={{click:this.props.actionNext, value:"Continuar"}} prev={{click:this.props.actionPrev, value:"« Atrás."}} />
     </div>     

}


export class PageInfoFoto extends React.Component<MyProps2Butons, MyState>{
     render= () =>
     <div className="PageInfoFoto">
          <div className="center"><img src={logoRayados} className="logo" alt="Logo" /></div>
          <h3 className="important">Toma de Fotografía</h3>
          <p>A continuación deberás autorizar el uso de tu cámara y colocarte correctamente dentro de la 
               silueta marcada. Procura tomar la foto con un celular o cámara de computadora con buena 
               resolución para que pueda imprimirse correctamente. </p>
          <br />
          <p className="txtImportant">IMPORTANTE: la app no funciona via Facebook, Twitter o Instagram.<br /> Es necesario que abras Safari (IOS) o Chrome (Android)</p>
          <br /><br />
          <ButtonDouble next={{click:this.props.actionNext, value:"Continuar"}} prev={{click:this.props.actionPrev, value:"« Atrás."}} />
     </div>
}

export class PageTakeFoto extends React.Component<{actionNext:any}, MyState>{
     ModuleTakeFoto:any;

     initCamera(){
          this.ModuleTakeFoto.initCamera()
     }

     render= () =>
     <div className="PageTakeFoto">
          <div id="container">
               <img src={escudo} className="fpmg_logo" alt="Logo rayados" />
               <PageTakeFotoForm ref={ModuleTakeFoto => {this.ModuleTakeFoto = ModuleTakeFoto}} actionNext={this.props.actionNext} />
          </div>
     </div>
}

type  PageShowFotoProps= {
     actionPrev?:any
     actionLoading?:any
     actionComplete:any
     clientAPollo:any
}

export class PageShowFoto extends React.Component<PageShowFotoProps, MyState>{

     preUpload= () =>{
          this.props.actionLoading();
          this.uploadFoto();
     }


     uploadFoto= async()=> {

          try{
               console.log("Init upload foto")
               let response=await this.props.clientAPollo.mutate({
                    mutation: gql`
                         mutation createCardboardFanRegisterImage($contentType:String){
                         createCardboardFanRegisterImage(input:{contentType:$contentType}){
                              presignedUrl,
                              contentType,
                              key
                         }}`,
                    variables:{
                         'contentType':"image/jpeg"
                    }
               });
               console.log("Create token:",JSON.stringify(response))

               let canvas:any=document.getElementById('videocanvas');
               let imageBase64=await fetch(canvas.toDataURL('image/jpeg'))

               console.log("Intentado subir la foto")
               await axios.put(response.data.createCardboardFanRegisterImage.presignedUrl,await imageBase64.blob(),{ 
                    headers: { 
                         'Content-Type': "image/jpeg" 
                    }
               });

               console.log("Imagen upload")
               //la response del archivo subido para referecniarlo
               this.props.actionComplete(response.data.createCardboardFanRegisterImage)

          }catch(e){
               console.log(e.response);
               console.log("ERROR:",JSON.stringify(e));
               //@ts-ignore
               Sentry.captureException(e);
               alert(e.message)
               this.props.actionPrev()
          }
     }

     render= () =>
     <div className="PageInfoFoto">
              <div className="peview">
                <img src={logoRayados} className="fpmg_logo" alt="Logo rayados" />
                <div className="buttom">
                    <button type="button" onClick={this.props.actionPrev} className="high btn-fpmg ">Nueva foto</button>
                    <button type="button" onClick={this.preUpload} className="high btn-fpmg">Continuar</button>
                </div>
                <canvas id="videocanvas" className="captured_image" width="1920" height="1080" />
              </div>
     </div>
}


export class PageLoading extends React.Component<{message:String}, MyState>{
     render= () =>
     <div className="PageLoading">
            <div className="uploadimage">
                <img src={logoRayados} className="fpmg_logo" alt="Logo rayados " />
                <h3>
                  <br />
                  {this.props.message}
                </h3>
                
                <div className="facebokcenter">
                  <div className="lds-facebook"><div></div><div></div><div></div></div>
                </div>
            </div>   
     </div>
}

export class PageInfoDonativo extends React.Component<MyPropsButon, MyState>{
     render= () =>
     <div className="precios">
     <img src={logoRayados} className="fpmg_logo" alt="Logo rayados " />
     <h3>Conoce tus opciones de donativo:</h3>
       <ul>
         <li><strong>$199</strong> - Tu silueta Rayada será impresa y colocada en las tribunas del Estadio BBVA para que apoyes al Equipo desde las gradas en los 
              partidos de local que se realicen a puerta cerrada.</li>
           <li className="tachado"><strong>$349</strong> - Además de adquirir tu silueta Rayada, participas para llevártela autografiada por tu jugador favorito del Primer Equipo una vez 
           que se termine la campaña.</li>
           <li className="tachado"><strong>$699 </strong>- Además de adquirir tu silueta Rayada, participas para ganarte el nuevo jersey local PUMA de la temporada 2020-2021.</li>                                            
       </ul>
       <p>*En cualquier opción seleccionada, todas las ganancias de tu aportación serán donadas a Unir y Dar. </p>
       <ButtonSingle click={this.props.actionNext} value="Continuar" priority="high" />
     </div>          
}


export class PageRegistro extends React.Component<{actionComplete:any,clientAPollo:any},{}>{
     RegistroForm: any;

     updateState= (newState:object) => this.RegistroForm.updateState(newState);

     render= () =>
     <div className="formulario">
          <img src={logoRayados}  className="fpmg_logo" alt="Rayads" />
          <h3>Compártenos la siguiente información para poder procesar tu pedido:</h3>
          <RegistroForm actionComplete={this.props.actionComplete}  clientAPollo={this.props.clientAPollo} ref={itemRef => {this.RegistroForm = itemRef}} />
     </div>
     
}

export class PageComplete extends React.Component<{},MyState>{
     
     updateState= (newState:object) => this.setState(newState);


     render= () =>
     <div className="tanks">
          <img src={logoRayados} className="fpmg_logo" alt="Logo rayados " />
          <br /><br />
          <h3>¡Gracias por tu apoyo!</h3>
          <p>No olvides estar al pendiente del correo electrónico que proporcionaste, pues este será nuestro principal medio de comunicación contigo.<br /><br />
          <div className="imageResponsive"><img src={splashfinal} /></div>
          </p>
     </div>
}